require.register("app/restaurant/export/ExcelModal", function(exports, require, module){
  $0
  
});

